<script>
  import { fade, scale } from 'svelte/transition';
  import { quintOut } from 'svelte/easing';
  import { X } from 'lucide-svelte';
  import Portal from 'svelte-portal';

  export let open = false;
  export let popupEl = null;
  export let popupPos = { x: 0, y: 0 };
  export let popupSide = 'left';
  export let reactionOptions = [];
  export let activeReaction = null;
  export let interactionMode = 'desktop';
  export let onEnter = () => {};
  export let onLeave = () => {};
  export let onSelect = () => {};
  export let onRemove = () => {};
</script>

<Portal>
  {#if open}
    <!-- svelte-ignore a11y_click_events_have_key_events -->
    <!-- svelte-ignore a11y_no_static_element_interactions -->
    <div
      bind:this={popupEl}
      class="fixed reaction-popup z-[9999]"
      class:reaction-popup--right={popupSide === 'right'}
      class:reaction-popup--left={popupSide === 'left'}
      class:reaction-popup--mobile={interactionMode === 'mobile'}
      style:top={`${popupPos.y}px`}
      style:left={popupSide === 'left' ? `${popupPos.x}px` : 'auto'}
      style:right={popupSide === 'right' ? `${popupPos.x}px` : 'auto'}
      on:mouseenter={onEnter}
      on:mouseleave={onLeave}
      on:pointerenter={onEnter}
      on:pointerleave={onLeave}
      on:click|stopPropagation
      in:scale={{ duration: 160, start: 0.92, easing: quintOut }}
      out:fade={{ duration: 120 }}>
      {#each reactionOptions as reaction}
        <button
          type="button"
          class="reaction-emoji"
          class:reaction-emoji--active={reaction === activeReaction}
          aria-label={reaction === activeReaction ? `Thả thêm cảm xúc ${reaction}` : `Chọn cảm xúc ${reaction}`}
          aria-pressed={reaction === activeReaction}
          on:click={() => onSelect(reaction)}>
          <span>{reaction}</span>
        </button>
      {/each}

      {#if activeReaction}
        <span class="reaction-popup__divider" aria-hidden="true"></span>
        <button
          type="button"
          class="reaction-remove"
          aria-label="Thu hồi cảm xúc"
          title="Thu hồi cảm xúc"
          on:click={onRemove}>
          <X size={18} strokeWidth={2.2} />
        </button>
      {/if}
    </div>
  {/if}
</Portal>

<style>
  .reaction-popup {
    display: flex;
    align-items: center;
    gap: 0.125rem;
    padding: 0.2rem;
    border-radius: 999px;
    border: 1px solid rgba(226, 232, 240, 0.92);
    background: rgba(255, 255, 255, 0.98);
    box-shadow: 0 10px 24px rgba(15, 23, 42, 0.12);
    backdrop-filter: blur(10px);
    touch-action: none;
    -webkit-touch-callout: none;
    -webkit-user-select: none;
    user-select: none;
  }

  .reaction-popup--left {
    transform-origin: left bottom;
  }

  .reaction-popup--right {
    transform-origin: right bottom;
  }

  .reaction-popup__divider {
    width: 1px;
    align-self: stretch;
    margin: 0 0.18rem;
    background: rgba(203, 213, 225, 0.9);
  }

  .reaction-emoji {
    display: grid;
    place-items: center;
    width: 1.4rem;
    height: 1.4rem;
    border-radius: 999px;
    border: 0;
    background: transparent;
    color: inherit;
    transition:
      transform 120ms ease,
      background-color 120ms ease;
  }

  .reaction-emoji:hover {
    transform: scale(1.08);
    background: rgba(241, 245, 249, 0.95);
  }

  .reaction-emoji--active {
    background: rgba(219, 234, 254, 0.95);
  }

  .reaction-remove {
    display: grid;
    place-items: center;
    width: 1.5rem;
    height: 1.5rem;
    border: 0;
    border-radius: 999px;
    background: transparent;
    color: #64748b;
    transition:
      transform 120ms ease,
      background-color 120ms ease,
      color 120ms ease;
  }

  .reaction-remove:hover {
    transform: scale(1.06);
    color: #475569;
    background: rgba(241, 245, 249, 0.96);
  }

  .reaction-popup--mobile {
    gap: 0.14rem;
    padding: 0.18rem 0.22rem;
  }

  .reaction-popup--mobile .reaction-emoji {
    width: 1.72rem;
    height: 1.72rem;
    font-size: 0.92rem;
  }

  .reaction-popup--mobile .reaction-remove {
    width: 1.78rem;
    height: 1.78rem;
  }

  @media (max-width: 640px) {
    .reaction-emoji {
      width: 1.72rem;
      height: 1.72rem;
    }
  }
</style>
